import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { COMPLETE_REUPLOAD_TRANSFER, GET_TRANSFER_VIEW_DETAILS_COMPLETE } from 'src/app/core/constants/api-endpoints';
import { ACCESS_TOKEN, AUTHORIZATION, BEARER_TOKEN_PREFIX } from 'src/app/core/constants/app-strings';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TransferService {

  constructor(
    private http: HttpClient
  ) { }

  /**
   * This endpoint returns a complete sw_transfer data at the DataService level, but filter out the essential data 
   * at API level
   * @param transactionId 
   * @returns 
   */
  getTransferDetails(transactionId: string): Observable<any> {
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    const url = environment.APIURL + GET_TRANSFER_VIEW_DETAILS_COMPLETE + `/${transactionId}`;
    return this.http.get<any>(url, { headers });
  }

  /**
   * Mark the transfer's reuploaded as complete
   * @param transferId 
   * @returns 
   */
  completeReupload(transferId: number) {
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    const url = environment.APIURL + COMPLETE_REUPLOAD_TRANSFER + `?transferId=${transferId}`;
    return this.http.post<any>(url, undefined, { headers });
  }
}
